// src/pages/HomePage.jsx
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Button,
  Grid,
  Paper,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import FormBuilderIcon from '@mui/icons-material/Build'; // Example icon
import EditIcon from '@mui/icons-material/Edit'; // Icon for editing
import Image from '../components/Black1x.png';

// Optional: Styled Paper for background
const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

function HomePage() {
  return (
    <Container maxWidth="md" sx={{ marginTop: 8 }}>
      <StyledPaper elevation={3}>
        <Grid container spacing={4} alignItems="center">
          {/* Illustration or Icon */}
          <Grid item xs={12} md={6}>
            {/* Replace with an actual image if available 
            <FormBuilderIcon style={{ fontSize: 100, color: '#1976d2' }} /> */}
            {/* Alternatively, use an image:*/}
            <img src={Image} alt="Form Builder Illustration" style={{ maxWidth: '80%', height: 'auto' }} />
            
          </Grid>

          {/* Welcome Text and Buttons */}
          <Grid item xs={12} md={6}>
            <Box>
              <Typography variant="h4" component="h1" gutterBottom>
                Welcome to the Form Builder
              </Typography>
              <Typography variant="subtitle1" color="textSecondary" paragraph>
                Easily create, customize, and manage your forms with our intuitive builder.
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, marginTop: 2 }}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  component={RouterLink}
                  to="/create-form"
                  sx={{
                    paddingX: 4,
                    paddingY: 1.5,
                    borderRadius: '25px',
                    color: 'black',
                    backgroundColor: '#ffd902',
                    '&:hover': {
                      backgroundColor: '#fff',
                      color: '#0026FD'
                    },
                  }}
                  startIcon={<FormBuilderIcon />}
                >
                  Create a New Form
                </Button>

                <Button
                  variant="outlined"
                  color="primary"
                  size="large"
                  component={RouterLink}
                  to="/edit-form"
                  sx={{
                    paddingX: 4,
                    paddingY: 1.5,
                    borderRadius: '25px',
                    borderColor: '#0026FD',
                    color: '#0026FD',
                    '&:hover': {
                      backgroundColor: '#fcf7d9',
                      borderColor: '#ffd902',
                      color: '#ffd902',
                    },
                  }}
                  startIcon={<EditIcon />}
                >
                  Edit an Existing Form
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </StyledPaper>
    </Container>
  );
}

export default HomePage;
